<div
  *ngIf="loading"
  class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10"
>
  <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
  <div class="flex flex-col justify-center items-center">
    <mat-spinner></mat-spinner>
    <span
      *ngIf="step != 2"
      class="text-sm md:text-xl text-primary font-normal z-10"
      >Autocompletando...</span
    >
  </div>
</div>
<div class="mb-2 p-2 bg-gray-100">
  <div class="flex items-center">
    <a
      (click)="goBack()"
      class="text-sm py-1 font-semibold text-primary hover:text-secondary transition ease-linear cursor-pointer"
    >
      < Volver a {{ product?.name }}</a
    >
  </div>
  <!-- <div>
    <img
    *ngIf="step === 1"
    class="hidden sm:block h-28 mx-auto"
    src="assets/purchase-step-1.png"
    alt=""
  />
  <img
    *ngIf="step === 2"
    class="hidden sm:block h-28 mx-auto"
    src="assets/purchase-step-2.png"
    alt=""
  />
  <img
    *ngIf="step === 2"
    class="hidden sm:block h-28 mx-auto"
    src="assets/purchase-step-3.png"
    alt=""
  />
  </div> -->
</div>
<section class="md:px-20 md:mb-5">
  <div class="grid grid-cols-1 md:grid-cols-2 rounded">
    <div
      *ngIf="product"
      class="col-span-1 rounded-l-xl px-2 md:px-32 min-w-[250px] mb-4"
    >
      <div class="" style="min-width: 250px">
        <h1
          class="bg-gradient-to-br from-primary to-blue-900 rounded-t-2xl text-white text-center p-3 font-bold shadow-medium"
        >
          {{ detailText }}
        </h1>
        <div
          class="bg-gradient-to-b from-gray-50 to-white p-5 md:pb-10 md:px-10 pt-0"
        >
          <img
            [src]="product.imageUrl"
            class="mx-auto w-24 mt-4"
            alt="imagen del producto"
          />
          <div class="text-xl md:text-2xl font-bold text-primary text-center">
            {{ product?.name }}
          </div>
          <div class="text-primary text-sm justify-between">
            <div
              *ngIf="product?.short_description"
              [innerHTML]="product?.short_description"
              class="bg-white rounded-2xl shadow-medium mt-5 mb-5 p-4"
            ></div>
            <div
              *ngIf="type === 'sub'"
              class="flex items-center justify-center bg-white shadow-medium rounded-2xl p-3 md:p-5"
            >
              <!-- Si no tiene descuento o cupón aplicado -->
              <div class="text-base" *ngIf="!discount && !isCouponValid">
                <p class="font-normal mb-2">
                  {{ serviceText }}
                  <span class="font-semibold text-primary">
                    {{ serviceName }}
                  </span>
                </p>
                <div class="mb-3">
                  <div class="font-semibold text-primary mb-1">
                    Precio mensual:
                  </div>
                  <div class="flex items-baseline gap-2">
                    <span
                      *ngIf="
                        +getPrice(product)?.original_price !==
                        +getPrice(product)?.price
                      "
                      class="line-through text-gray-400 text-base"
                    >
                      ${{
                        formatNumber(getPrice(product)?.original_price || 0)
                      }}
                    </span>
                    <span
                      class="font-extrabold text-2xl md:text-3xl"
                      [class.text-green-600]="
                        +getPrice(product)?.original_price !==
                        +getPrice(product)?.price
                      "
                      [class.text-primary]="
                        +getPrice(product)?.original_price ===
                        +getPrice(product)?.price
                      "
                    >
                      ${{ formatNumber(getPrice(product)?.price || 0) }}
                    </span>
                    <span class="text-sm text-gray-600">{{ isSubsText }}</span>
                  </div>
                </div>
                <p class="font-normal mb-2">
                  <span class="font-medium text-gray-700"
                    >Precio sin impuestos nacionales:</span
                  >
                  <span class="font-semibold ml-1"
                    >${{
                      formatNumber((getPrice(product)?.price || 0) / 1.21)
                    }}</span
                  >
                  <span class="text-xs text-gray-500 ml-1">{{
                    isSubsText
                  }}</span>
                </p>
                <p class="font-normal">
                  <ng-container
                    *ngIf="getPrice(product).cost == 0; else showInstallCost"
                  >
                    <span
                      class="inline-flex items-center px-4 py-0.5 rounded-full bg-green-50 text-green-700 ring-1 ring-green-200 text-xs font-semibold"
                    >
                      Instalación Gratis
                    </span>
                  </ng-container>
                  <ng-template #showInstallCost>
                    <span class="font-semibold">Costo de Instalación:</span>
                    <span class="font-semibold text-primary ml-1"
                      >${{ formatNumber(getPrice(product).cost) }} x única</span
                    >
                  </ng-template>
                </p>
              </div>

              <!-- Si tiene cupón aplicado -->
              <div
                class="text-base"
                *ngIf="isCouponValid && couponDiscount && periodicity"
              >
                <div
                  class="mb-3 p-3 bg-gradient-to-r from-green-50 to-emerald-50 shadow-medium rounded-2xl"
                >
                  <div class="flex items-center gap-2">
                    <mat-icon class="text-green-600 text-base"
                      >local_offer</mat-icon
                    >
                    <span class="text-green-800 font-semibold text-sm"
                      >Cupón aplicado: {{ couponDiscount.code }}</span
                    >
                  </div>
                </div>

                <p class="font-normal mb-2">
                  {{ serviceText }}
                  <span class="font-semibold text-primary">
                    {{ serviceName }}
                  </span>
                </p>

                <!-- Precio periódico con descuento -->
                <div class="mb-3">
                  <div class="font-semibold text-primary mb-1">
                    Precio mensual:
                  </div>
                  <div class="flex items-baseline gap-2 flex-wrap">
                    <div class="flex items-baseline gap-2">
                      <span
                        *ngIf="
                          +getPrice(product)?.original_price !==
                          +getPrice(product)?.price
                        "
                        class="line-through text-gray-400 text-base"
                      >
                        ${{
                          formatNumber(getPrice(product)?.original_price || 0)
                        }}
                      </span>
                      <span
                        class="font-extrabold text-2xl md:text-3xl"
                        [class.text-green-600]="
                          +getPrice(product)?.original_price !==
                          +getPrice(product)?.price
                        "
                        [class.text-primary]="
                          +getPrice(product)?.original_price ===
                          +getPrice(product)?.price
                        "
                      >
                        ${{ formatNumber(getPrice(product)?.price || 0) }}
                      </span>
                      <span class="text-sm text-gray-600">{{
                        isSubsText
                      }}</span>
                    </div>
                    <span
                      *ngIf="
                        isCouponValid &&
                        couponDiscount?.operation === '%' &&
                        couponDiscount?.amount > 0
                      "
                      class="text-sm font-bold bg-green-100 text-green-700 px-3 py-1 rounded-full"
                    >
                      -{{ couponDiscount?.amount }}% OFF
                    </span>
                  </div>
                </div>

                <p class="font-normal mb-2">
                  <span class="font-medium text-gray-700"
                    >Precio sin impuestos nacionales:</span
                  >
                  <span class="font-semibold ml-1"
                    >${{
                      formatNumber((getPrice(product)?.price || 0) / 1.21)
                    }}</span
                  >
                  <span class="text-xs text-gray-500 ml-1">{{
                    isSubsText
                  }}</span>
                </p>

                <!-- Costo de instalación con descuento -->
                <div class="font-normal">
                  <ng-container
                    *ngIf="
                      getPrice(product)?.cost === 0 ||
                        getPrice(product)?.cost === null;
                      else showDiscountedInstall
                    "
                  >
                    <span
                      class="inline-flex items-center px-4 py-0.5 rounded-full bg-green-50 text-green-700 ring-1 ring-green-200 text-xs font-semibold"
                    >
                      Instalación Gratis
                    </span>
                  </ng-container>
                  <ng-template #showDiscountedInstall>
                    <span class="font-semibold">Costo de Instalación:</span>
                    <span
                      *ngIf="
                        getPrice(product)?.original_cost &&
                        getPrice(product)?.original_cost > 0 &&
                        getPrice(product)?.original_cost !==
                          getPrice(product)?.cost
                      "
                      class="line-through text-red-400 text-sm ml-1"
                    >
                      ${{ formatNumber(getPrice(product)?.original_cost || 0) }}
                    </span>
                    <span class="font-semibold text-green-600 ml-1">
                      ${{ formatNumber(getPrice(product)?.cost || 0) }}
                    </span>
                    <span
                      *ngIf="
                        periodicity?.pivot?.install_discount_percentage > 0 &&
                        couponDiscount?.code !== 'AGUATODOELDIA'
                      "
                      class="ml-2 text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full"
                    >
                      -{{ periodicity?.pivot?.install_discount_percentage }}%
                    </span>
                  </ng-template>
                </div>

                <p
                  *ngIf="couponDiscount.months"
                  class="text-xs text-gray-600 mt-2"
                >
                  * Descuento válido por {{ couponDiscount.months }} meses
                </p>
              </div>

              <!-- Si tiene descuento -->
              <div class="text-base" *ngIf="discount">
                <p class="font-normal mb-2">
                  <span class="font-semibold text-primary">Suscripción:</span>
                  <span class="font-semibold ml-1">{{
                    periodicity?.name
                  }}</span>
                </p>
                <div class="font-normal mb-2">
                  <span class="font-semibold text-primary">Precio:</span>
                  <span *ngIf="!discount"
                    >${{ formatNumber(periodicity?.periodic_price) }}
                    {{ isSubsText }}</span
                  >
                  <div *ngIf="discount" class="inline-block ml-1">
                    <span
                      style="
                        text-decoration: line-through;
                        color: rgb(248 113 113);
                      "
                      >$
                      {{ formatNumber(getPrice(product).original_price) }}</span
                    >
                    <span
                      *ngIf="discount"
                      class="font-extrabold text-green-600 text-lg md:text-2xl ml-1"
                    >
                      ${{ formatNumber(getPrice(product).price) }}
                    </span>
                    <span class="text-gray-700 font-light text-sm ml-1">{{
                      getPrice(product).periodicity_label
                    }}</span>
                  </div>
                </div>
                <p class="font-normal">
                  <span class="font-semibold">Instalacion:</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(248 113 113);
                    "
                  >
                    $ {{ formatNumber(periodicity?.pivot?.price) }}</span
                  ><br />
                  <span
                    class="inline-flex items-center px-4 py-0.5 rounded-full bg-green-50 text-green-700 ring-1 ring-green-200 text-xs font-semibold ml-2"
                    >Instalación Gratis</span
                  >
                </p>
              </div>
            </div>
            <div
              *ngIf="type === 'sale'"
              class="flex flex-col items-center justify-center bg-white shadow-medium rounded-2xl p-3 md:p-5"
            >
              <!--<p
                class="font-semibold mb-2 text-base p-2 px-2"
              >
                {{ serviceName }}
              </p>-->
              <div class="flex justify-center items-center text-center">
                <!-- Precio tachado -->
                <div>
                  <span class="text-primary">Precio de lista: </span
                  ><strong class="text-secondary line-through"
                    >${{ formatNumber(product?.tachado) }}</strong
                  >
                </div>

                <!-- Círculo de descuento -->
                <div
                  class="bg-secondary text-white font-bold w-8 h-8 rounded-full text-sm flex items-center justify-center p-5 ml-2"
                >
                  {{ getSalePrice(product, 0)?.percentage }}%
                </div>
              </div>
              <!--<p class="font-normal mb-2">
                Precio final:
                <strong>${{ formatNumber(getPrice(product)?.price) }}</strong>
              </p>-->
              <p class="font-normal mb-2 text-gray-500" style="font-size: 10px">
                Precio sin impuestos nacionales:
                <strong
                  >${{ formatNumber(getPrice(product).price / 1.21) }}</strong
                >
              </p>
            </div>
          </div>
        </div>
        <div
          *ngIf="type === 'sub'; showSale"
          class="bg-gradient-to-br from-primary to-blue-900 rounded-b-2xl text-white text-center shadow-medium p-3"
        >
          <p class="font-semibold">
            Precio Final:
            <span class="font-medium">
              ${{
                formatNumber(
                  getPrice(product)?.price ||
                    periodicity?.pivot?.periodic_price ||
                    0
                )
              }}</span
            >
            <span class="text-sm font-light">
              {{ getPrice(product)?.periodicity_label || isSubsText }}</span
            >
          </p>
        </div>

        <div
          *ngIf="type === 'sale'"
          class="bg-gradient-to-br from-primary to-blue-900 rounded-b-2xl text-white text-center shadow-medium"
        >
          <div
            class="bg-gradient-to-br from-primary to-blue-900 text-white rounded-2xl p-5 mb-3"
          >
            <p class="text-xs uppercase tracking-wider">
              Precio final con descuento
            </p>
            <div class="flex flex-col">
              <div class="text-xl font-bold my-2">
                ${{ formatNumber(getSalePrice(product, 0)?.price) }}
              </div>
              <img
                class="bg-gray-100 rounded-lg w-full h-37"
                src="assets/formas_de_pago.png"
                alt="Mercado Pago logo"
              />
            </div>
            <div
              class="bg-white/20 backdrop-blur-sm rounded-lg p-2 mt-3 border border-white/30"
            >
              <div class="text-center">
                <span class="text-xs uppercase tracking-wider"
                  >ENVÍO GRATIS *</span
                >
              </div>
            </div>
            <!-- Cuotas sin interés dentro de la tarjeta -->
            <div
              class="bg-white/20 backdrop-blur-sm rounded-2xl p-3 mt-3 shadow-medium"
            >
              <div class="text-center">
                <span class="text-xs uppercase tracking-wider"
                  >HASTA 6 CUOTAS SIN INTERÉS DE</span
                >
                <div class="text-xl font-bold">
                  ${{
                    calculateInterestFreeInstallments(
                      getSalePrice(product, 0)?.price,
                      6
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="type === 'sale' && step !== 2"
          class="hidden md:block bg-gradient-to-b from-gray-50 to-white rounded-2xl p-4 mt-3 shadow-medium"
        >
          <div class="flex flex-col text-center">
            <div class="font-normal text-xs space-y-1 text-left inline-block">
              <p>
                <span class="font-bold">•</span> CABA y GBA:
                <span class="font-semibold">1 día hábil</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Pcia de Bs As, Capitales de
                Córdoba, Entre Ríos, Mendoza, Neuquén y Santa Fé:
                <span class="font-semibold">Hasta 3 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Resto de Provincias
                continentales:
                <span class="font-semibold">Hasta 7 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Tierra del Fuego:
                <span class="font-semibold">Hasta 14 días hábiles</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!product" class="col-span-1 px-32 py-10">
      <div
        class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10"
      >
        <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div
      *ngIf="step === 1"
      class="col-span-1 bg-white rounded-r-2xl px-2 md:px-4 shadow-medium"
    >
      <div *ngIf="!isLogged">
        <div class="flex gap-2 p-2">
          <div
            class="px-7 py-3 rounded-2xl cursor-pointer font-semibold transition-all"
            [ngClass]="{
              'bg-gradient-to-br from-primary to-blue-900 text-white shadow-medium':
                mode === 'register',
              'bg-gray-100 text-primary hover:bg-gray-200': mode !== 'register'
            }"
            (click)="changeMode('register')"
          >
            {{ type === "sale" ? "Datos de envío" : "Datos de instalación" }}
          </div>
          <div
            class="px-7 py-3 rounded-2xl cursor-pointer font-semibold transition-all"
            [ngClass]="{
              'bg-gradient-to-br from-primary to-blue-900 text-white shadow-medium':
                mode === 'login',
              'bg-gray-100 text-primary hover:bg-gray-200': mode !== 'login'
            }"
            (click)="changeMode('login')"
          >
            Iniciar Sesión
          </div>
        </div>
        <div *ngIf="mode === 'register'" class="md:px-10 px-4 py-10">
          <form [formGroup]="registerForm" (ngSubmit)="register()">
            <!-- === SECCIÓN DATOS DE CONTACTO === -->
            <div class="w-fit mb-6 mx-4 md:mx-0">
              <h3 class="text-lg font-bold text-primary">Datos del titular</h3>
              <div
                class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
              ></div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
              <!-- Género -->
              <div *ngIf="!empresaSelect && type === 'sub'" class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Género <span class="text-red-500">*</span></label
                >
                <select
                  formControlName="gender"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                >
                  <option value="" disabled selected>Seleccionar</option>
                  <option *ngFor="let option of genders" [value]="option">
                    {{ option }}
                  </option>
                </select>
              </div>

              <!-- DNI / CUIT -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >{{ empresaSelect ? "CUIT" : "DNI" }}
                  <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="document"
                  type="number"
                  [placeholder]="empresaSelect ? 'Ingrese CUIT' : 'Ingrese DNI'"
                  (input)="preventNegativeInput($event)"
                  (blur)="onDocumentBlur($event)"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>

              <!-- Nombre / Razón Social -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >{{ !empresaSelect ? "Nombre completo" : "Razón Social" }}
                  <span class="text-red-500">* (autocompletado)</span></label
                >
                <input
                  formControlName="full_name"
                  type="text"
                  [placeholder]="
                    !empresaSelect ? 'Nombre completo' : 'Razón Social'
                  "
                  [readonly]="type === 'sub'"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  [class.bg-gray-100]="type === 'sub'"
                />
              </div>

              <!-- Email -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Email <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="email"
                  type="email"
                  placeholder="correo@ejemplo.com"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>

              <!-- Mensaje de error para email -->
              <ng-container *ngIf="errors && errors.email">
                <p
                  class="text-red-500 text-sm mb-2"
                  *ngFor="let error of errors.email"
                >
                  {{ error }}
                </p>
              </ng-container>

              <!-- Teléfono -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Teléfono <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="phone"
                  type="text"
                  placeholder="Ej: 1123456789"
                  (input)="onlyNumbers($event)"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>

              <!-- IVA Exento -->
              <div
                *ngIf="empresaSelect"
                class="flex items-center justify-start"
              >
                <mat-checkbox formControlName="iva_exempt"
                  >IVA Exento</mat-checkbox
                >
              </div>
            </div>

            <!-- === SECCIÓN DIRECCIÓN === -->
            <div class="w-fit mb-6 mx-4 md:mx-0 mt-8">
              <h3 class="text-lg font-bold text-primary">
                Dirección de
                {{ type === "sale" ? "envío" : "instalación" }}
              </h3>
              <div
                class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
              ></div>
            </div>
            <form [formGroup]="stepOneForm" class="space-y-2">
              <p class="text-primary text-sm -mb-1 ml-1">
                Busca tu dirección y selecciónala en el listado.
              </p>
              <!-- Buscador de Dirección -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Dirección completa<span class="text-red-500">*</span></label
                >
                <div class="relative">
                  <input
                    ngx-google-places-autocomplete
                    [options]="options"
                    #placesRef="ngx-places"
                    placeholder="Ej: Camarones 1981"
                    (onAddressChange)="handleAddressChange($event)"
                    formControlName="street"
                    type="search"
                    [ngModel]="street"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    [class.border-green-500]="isZipCodeValid"
                    [class.border-red-500]="zipCodeError"
                  />
                  <div
                    *ngIf="isValidatingZipCode"
                    class="absolute right-3 top-1/2 transform -translate-y-1/2"
                  >
                    <mat-spinner diameter="20"></mat-spinner>
                  </div>
                  <div
                    *ngIf="isZipCodeValid && !isValidatingZipCode"
                    class="absolute right-3 top-1/2 transform -translate-y-1/2"
                  >
                    <mat-icon class="text-green-600">check_circle</mat-icon>
                  </div>
                </div>
                <p
                  *ngIf="zipCodeError"
                  class="text-red-600 text-xs mt-1 font-semibold"
                >
                  {{ zipCodeError }}
                </p>
              </div>

              <!-- Campos de Dirección -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Número <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="street_number"
                    type="number"
                    placeholder="Número"
                    [ngModel]="street_number"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Piso/Depto./Timbre</label
                  >
                  <input
                    formControlName="floor"
                    type="text"
                    placeholder="Ej: 3B"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Ciudad <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="city"
                    [(ngModel)]="city"
                    type="search"
                    placeholder="Ciudad"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Provincia <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="province"
                    [(ngModel)]="province"
                    type="search"
                    placeholder="Provincia"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Barrio/Localidad</label
                  >
                  <input
                    formControlName="department"
                    type="search"
                    placeholder="Barrio/Localidad"
                    [(ngModel)]="department"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Código Postal <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="postal_code"
                    [(ngModel)]="zipCode"
                    type="string"
                    placeholder="Código Postal"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
              </div>

              <!-- Comentarios -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Comentarios (ej. entre calles, reja negra, etc.)</label
                >
                <textarea
                  formControlName="observations"
                  rows="2"
                  placeholder="Agregue detalles adicionales..."
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full resize-none"
                ></textarea>
              </div>

              <!-- Checkbox misma dirección para facturación -->
              <div class="flex items-center py-2">
                <mat-checkbox
                  formControlName="sameAddressAsInstallation"
                  class="text-primary"
                  [checked]="true"
                >
                  Usar misma dirección para facturación
                </mat-checkbox>
              </div>

              <!-- === SECCIÓN DATOS DE FACTURACIÓN (CONDICIONAL) === -->
              <div
                *ngIf="!stepOneForm.get('sameAddressAsInstallation')?.value"
                class="space-y-2"
              >
                <div class="w-fit mb-6 mx-4 md:mx-0 mt-8">
                  <h3 class="text-lg font-bold text-primary">
                    Datos de Facturación
                  </h3>
                  <div
                    class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
                  ></div>
                </div>
                <!-- Dirección completa con Autocomplete (Facturación) -->
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2">
                    Dirección completa <span class="text-red-500">*</span>
                  </label>
                  <input
                    ngx-google-places-autocomplete
                    [options]="options"
                    #billPlacesRefOne="ngx-places"
                    placeholder="Ej: Camarones 1981"
                    (onAddressChange)="
                      handleBillingAddressChange($event, 'stepOne')
                    "
                    formControlName="bill_street"
                    type="search"
                    [ngModel]="bill_street"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Calle <span class="text-red-500">*</span></label
                    >
                    <input
                      formControlName="bill_street"
                      type="text"
                      placeholder="Calle"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Número <span class="text-red-500">*</span></label
                    >
                    <input
                      formControlName="bill_street_number"
                      type="number"
                      placeholder="Número"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Piso/Depto./Timbre</label
                    >
                    <input
                      formControlName="bill_floor"
                      type="text"
                      placeholder="Ej: 3B"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Ciudad <span class="text-red-500">*</span></label
                    >
                    <input
                      formControlName="bill_city"
                      type="text"
                      placeholder="Ciudad"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Provincia <span class="text-red-500">*</span></label
                    >
                    <input
                      formControlName="bill_province"
                      type="text"
                      placeholder="Provincia"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-primary mb-2"
                      >Código Postal <span class="text-red-500">*</span></label
                    >
                    <input
                      formControlName="bill_postal_code"
                      type="text"
                      placeholder="Código Postal"
                      class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                    />
                  </div>
                </div>
              </div>
            </form>

            <!-- === SECCIÓN FINAL === -->
            <!-- Cupón de Descuento (solo para suscripciones) -->
            <div *ngIf="type === 'sub'" class="mt-8">
              <div class="w-fit mb-6 mx-4 md:mx-0">
                <h3 class="text-lg font-bold text-primary">
                  ¿Tenés un cupón de descuento?
                </h3>
                <div
                  class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
                ></div>
              </div>
              <div class="flex gap-2 items-start">
                <div class="flex-1 relative">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Código del cupón</label
                  >
                  <div class="relative">
                    <input
                      [(ngModel)]="couponCode"
                      [ngModelOptions]="{ standalone: true }"
                      type="text"
                      placeholder="Ej: DESCUENTO2024"
                      [disabled]="isCouponValid"
                      class="border border-gray-300 rounded-lg px-4 py-3 pr-10 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full disabled:bg-gray-100"
                    />
                    <mat-icon
                      *ngIf="isCouponValid"
                      class="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-600"
                      >check_circle</mat-icon
                    >
                  </div>
                </div>
                <button
                  *ngIf="!isCouponValid"
                  type="button"
                  (click)="validateCoupon()"
                  [disabled]="couponLoading || !couponCode"
                  class="mt-8 bg-gradient-to-br from-primary to-blue-900 text-white px-6 py-3 rounded-full font-bold shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span *ngIf="!couponLoading">Aplicar</span>
                  <mat-spinner
                    *ngIf="couponLoading"
                    diameter="20"
                    class="inline-block"
                  ></mat-spinner>
                </button>
                <button
                  *ngIf="isCouponValid"
                  type="button"
                  (click)="clearCoupon()"
                  class="mt-8 bg-gradient-to-br from-red-600 to-red-700 text-white px-6 py-3 rounded-full font-bold shadow-medium hover:shadow-strong hover:scale-105 transition-all"
                >
                  Quitar
                </button>
              </div>

              <!-- Mensaje de éxito -->
              <div
                *ngIf="isCouponValid && couponDiscount"
                class="mt-2 p-4 bg-gradient-to-r from-green-50 to-emerald-50 shadow-medium rounded-2xl flex items-center gap-3"
              >
                <mat-icon class="text-green-600">check_circle</mat-icon>
                <div class="flex-1">
                  <p class="text-green-800 font-semibold">
                    ¡Cupón aplicado con éxito!
                  </p>
                  <p class="text-green-700 text-sm">
                    <span *ngIf="couponDiscount.operation === '%'">
                      {{ couponDiscount.amount }}% de descuento
                    </span>
                    <span *ngIf="couponDiscount.operation !== '%'">
                      ${{ couponDiscount.amount }} de descuento
                    </span>
                    <span *ngIf="couponDiscount.months">
                      por {{ couponDiscount.months }} meses</span
                    >
                  </p>
                </div>
              </div>

              <!-- Mensaje de error -->
              <div
                *ngIf="couponError"
                class="mt-2 p-4 bg-gradient-to-r from-red-50 to-rose-50 shadow-medium rounded-2xl flex items-center gap-3"
              >
                <mat-icon class="text-red-600">error</mat-icon>
                <p class="text-red-800 text-sm font-semibold">
                  {{ couponError }}
                </p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 mt-8">
              <!-- Cómo conoció Everfull -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >¿Cómo conoció Everfull?</label
                >
                <select
                  formControlName="met_way_id"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                >
                  <option value="" disabled selected>Seleccionar</option>
                  <option *ngFor="let metWay of metWays" [value]="metWay.id">
                    {{ metWay.name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Botón Continuar -->
            <button
              type="submit"
              [disabled]="
                !isZipCodeValid || zipCodeError || isValidatingZipCode
              "
              class="w-full mt-6 bg-gradient-to-br from-primary to-blue-900 text-white py-3 px-5 rounded-full text-base font-bold flex items-center justify-center shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span *ngIf="isValidatingZipCode" class="flex items-center gap-2">
                <mat-spinner diameter="16"></mat-spinner>
                Validando código postal...
              </span>
              <span *ngIf="!isValidatingZipCode">Continuar</span>
            </button>

            <!-- Mapa: mantener el contenedor siempre en el DOM para evitar errores de inicialización -->
            <div class="mt-6">
              <h3
                class="font-semibold text-lg text-primary mb-2"
                [ngStyle]="viewMap ? { display: 'block' } : { display: 'none' }"
              >
                Verifica el lugar en el mapa:
              </h3>
              <div
                id="map"
                class="w-full rounded-3xl mt-4"
                [ngClass]="{ 'shadow-lg': viewMap }"
                [ngStyle]="viewMap ? { 'height.px': 400 } : { 'height.px': 0 }"
              ></div>
            </div>
          </form>
        </div>
        <div
          *ngIf="type === 'sale'"
          class="md:hidden bg-gradient-to-b from-gray-50 to-white rounded-2xl p-4 mt-3 shadow-medium"
        >
          <div class="flex flex-col text-center">
            <div class="font-normal text-xs space-y-1 text-left inline-block">
              <p>
                <span class="font-bold">•</span> CABA y GBA:
                <span class="font-semibold">1 día hábil</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Pcia de Bs As, Capitales de
                Córdoba, Entre Ríos, Mendoza, Neuquén y Santa Fé:
                <span class="font-semibold">Hasta 3 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Resto de Provincias
                continentales:
                <span class="font-semibold">Hasta 7 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Tierra del Fuego:
                <span class="font-semibold">Hasta 14 días hábiles</span>.
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="mode === 'login'" class="md:px-10 px-4 py-10">
          <form [formGroup]="loginForm" (ngSubmit)="login()" class="space-y-6">
            <!-- Email -->
            <div>
              <label
                for="email"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Correo Electrónico
              </label>
              <div class="mt-1">
                <input
                  id="email"
                  formControlName="email"
                  name="email"
                  type="email"
                  autocomplete="email"
                  placeholder="tucorreo@example.com"
                  class="block w-full px-4 py-3 border border-gray-200 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary sm:text-sm bg-white"
                />
                <p
                  class="mt-1 text-xs text-rose-600"
                  *ngIf="
                    loginForm.get('email')?.invalid &&
                    (loginForm.get('email')?.dirty ||
                      loginForm.get('email')?.touched)
                  "
                >
                  Ingresá un correo válido.
                </p>
              </div>
              <ng-container *ngIf="errors && errors.email">
                <p
                  class="mt-1 text-xs text-rose-600"
                  *ngFor="let error of errors.email"
                >
                  {{ error }}
                </p>
              </ng-container>
            </div>

            <!-- Password -->
            <div>
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Contraseña
              </label>
              <div class="mt-1 relative">
                <input
                  id="password"
                  formControlName="password"
                  name="password"
                  [type]="changeType ? 'password' : 'text'"
                  autocomplete="current-password"
                  placeholder="Tu contraseña"
                  class="block w-full px-4 py-3 border border-gray-200 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary sm:text-sm bg-white pr-10"
                />
                <button
                  type="button"
                  (click)="viewPass()"
                  aria-label="Mostrar/Ocultar contraseña"
                  class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  <i [ngClass]="visible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                </button>
                <p
                  class="mt-1 text-xs text-rose-600"
                  *ngIf="
                    loginForm.get('password')?.invalid &&
                    (loginForm.get('password')?.dirty ||
                      loginForm.get('password')?.touched)
                  "
                >
                  La contraseña es obligatoria.
                </p>
              </div>
              <ng-container *ngIf="errors && errors.password">
                <p
                  class="mt-1 text-xs text-rose-600"
                  *ngFor="let error of errors.password"
                >
                  {{ error }}
                </p>
              </ng-container>
            </div>

            <!-- Forgot password -->
            <div class="flex items-center justify-between">
              <div class="text-sm">
                <a
                  routerLink="/forgot-password"
                  class="font-medium text-primary hover:text-blue-700"
                >
                  Olvidé mi contraseña
                </a>
              </div>
            </div>

            <!-- Submit -->
            <div>
              <button
                type="submit"
                [disabled]="loading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50':
                    !loginForm.get('email')?.value &&
                    !loginForm.get('password')?.value
                }"
                class="w-full inline-flex justify-center items-center py-3 px-4 rounded-full text-sm font-bold text-white bg-gradient-to-br from-primary to-blue-900 shadow-medium hover:shadow-strong hover:scale-105 transition-all focus:outline-none"
              >
                Ingresar
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf="isLogged">
        <div *ngIf="updateDataType === 'user'">
          <p class="text-lg text-primary font-semibold">
            Bienvenido: {{ user?.name }} <br />
          </p>
          <form [formGroup]="updateUserForm" (ngSubmit)="updateUser()">
            <!-- Temporalmente oculto - funcionalidad de empresa deshabilitada -->
            <div style="display: none">
              <p class="text-primary mt-4">¿A donde llevarás la experiencia?</p>
              <mat-radio-group class="text-primary">
                <mat-radio-button
                  class="mr-10"
                  (change)="empresaSelect = false"
                  value="after"
                  checked="true"
                  >Hogar</mat-radio-button
                >
                <mat-radio-button
                  class=""
                  (change)="empresaSelect = true"
                  value="before"
                  >Empresa</mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div class="w-fit mb-6 mx-4 md:mx-0 mt-8">
              <h3 class="text-lg font-bold text-primary">Datos del titular</h3>
              <div
                class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
              ></div>
            </div>

            <!-- Cupón de Descuento (solo para suscripciones) -->
            <div *ngIf="type === 'sub'" class="mb-6">
              <div class="w-fit mb-6 mx-4 md:mx-0">
                <h3 class="text-base font-bold text-primary">
                  ¿Tenés un cupón de descuento?
                </h3>
                <div
                  class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
                ></div>
              </div>
              <div class="flex gap-2 items-start">
                <div class="flex-1 relative">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Código del cupón</label
                  >
                  <div class="relative">
                    <input
                      [(ngModel)]="couponCode"
                      [ngModelOptions]="{ standalone: true }"
                      type="text"
                      placeholder="Ej: DESCUENTO2024"
                      [disabled]="isCouponValid"
                      class="border border-gray-300 rounded-lg px-4 py-3 pr-10 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full disabled:bg-gray-100"
                    />
                    <mat-icon
                      *ngIf="isCouponValid"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-green-600 inline-flex items-center justify-center"
                      >check_circle</mat-icon
                    >
                  </div>
                </div>
                <button
                  *ngIf="!isCouponValid"
                  type="button"
                  (click)="validateCoupon()"
                  [disabled]="couponLoading || !couponCode"
                  class="mt-8 bg-gradient-to-br from-primary to-blue-900 text-white px-6 py-3 rounded-full font-bold shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span *ngIf="!couponLoading">Aplicar</span>
                  <mat-spinner
                    *ngIf="couponLoading"
                    diameter="20"
                    class="inline-block"
                  ></mat-spinner>
                </button>
                <button
                  *ngIf="isCouponValid"
                  type="button"
                  (click)="clearCoupon()"
                  class="mt-8 bg-gradient-to-br from-red-600 to-red-700 text-white px-6 py-3 rounded-full font-bold shadow-medium hover:shadow-strong hover:scale-105 transition-all"
                >
                  Quitar
                </button>
              </div>

              <!-- Mensaje de éxito -->
              <div
                *ngIf="isCouponValid && couponDiscount"
                class="mt-2 p-4 bg-gradient-to-r from-green-50 to-emerald-50 shadow-medium rounded-2xl flex items-center gap-3"
              >
                <mat-icon class="text-green-600">check_circle</mat-icon>
                <div class="flex-1">
                  <p class="text-green-800 font-semibold">
                    ¡Cupón aplicado con éxito!
                  </p>
                  <p class="text-green-700 text-sm">
                    <span *ngIf="couponDiscount.operation === '%'">
                      {{ couponDiscount.amount }}% de descuento
                    </span>
                    <span *ngIf="couponDiscount.operation !== '%'">
                      ${{ couponDiscount.amount }} de descuento
                    </span>
                    <span *ngIf="couponDiscount.months">
                      por {{ couponDiscount.months }} meses</span
                    >
                  </p>
                </div>
              </div>

              <!-- Mensaje de error -->
              <div
                *ngIf="couponError"
                class="mt-2 p-4 bg-gradient-to-r from-red-50 to-rose-50 shadow-medium rounded-2xl flex items-center gap-3"
              >
                <mat-icon class="text-red-600">error</mat-icon>
                <p class="text-red-800 text-sm font-semibold">
                  {{ couponError }}
                </p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              <div *ngIf="!empresaSelect && type === 'sub'" class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Género <span class="text-red-500">*</span></label
                >
                <select
                  formControlName="gender"
                  id="genero"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                >
                  <option value="" disabled selected>Seleccionar</option>
                  <option *ngFor="let option of genders" [value]="option">
                    {{ option }}
                  </option>
                </select>
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >{{ empresaSelect ? "CUIT" : "DNI" }}
                  <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="document"
                  type="number"
                  id="dni"
                  [placeholder]="empresaSelect ? 'Ingrese CUIT' : 'Ingrese DNI'"
                  (input)="preventNegativeInput($event)"
                  (blur)="onDocumentBlur($event)"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  [ngClass]="{
                    'border-red-500':
                      registerForm.controls.document.invalid &&
                      (registerForm.controls.document.dirty ||
                        registerForm.controls.document.touched)
                  }"
                />
              </div>

              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >{{ !empresaSelect ? "Nombre completo" : "Razon Social" }}
                  <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="full_name"
                  type="text"
                  id="username"
                  [placeholder]="
                    !empresaSelect ? 'Nombre completo' : 'Razón Social'
                  "
                  [readonly]="type === 'sub'"
                  defaultValue="{{ user?.name }}"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  [class.bg-gray-100]="type === 'sub'"
                />
              </div>

              <mat-checkbox
                *ngIf="empresaSelect"
                class="w-full"
                formControlName="iva_exempt"
                id="iva_exempt"
                >IVA Exento</mat-checkbox
              >

              <ng-container *ngIf="errors && errors.name">
                <p
                  class="text-red-500 mb-2 text-sm"
                  *ngFor="let error of errors.name"
                >
                  - {{ error }}
                </p>
              </ng-container>

              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Email <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="email"
                  type="email"
                  placeholder="correo@ejemplo.com"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>

              <ng-container *ngIf="errors && errors.email">
                <p
                  class="text-secondary mb-2 text-sm"
                  *ngFor="let error of errors.email"
                >
                  - {{ error }}
                </p>
              </ng-container>

              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Teléfono <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="phone"
                  type="text"
                  placeholder="{{ user?.phone || 'Ej: 1123456789' }}"
                  (input)="onlyNumbers($event)"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <ng-container *ngIf="errors && errors.phone">
                <p
                  class="text-red-500 mb-2 text-sm"
                  *ngFor="let error of errors.phone"
                >
                  - {{ error }}
                </p>
              </ng-container>
            </div>
            <div class="w-full mt-5">
              <label class="block text-sm font-medium text-primary mb-2"
                >¿Cómo conoció Everfull?</label
              >
              <select
                formControlName="met_way_id"
                id="met_way_id"
                class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
              >
                <option value="" disabled selected>Seleccionar</option>
                <option *ngFor="let metWay of metWays" [value]="metWay.id">
                  {{ metWay.name }}
                </option>
              </select>
            </div>
            <div class="flex gap-2">
              <button
                (click)="step = 2"
                class="bg-gray-100 text-primary py-2 px-5 rounded-full text-base md:text-xl font-bold m-5 hover:bg-gray-200 shadow-sm hover:shadow-medium transition-all"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="bg-gradient-to-br from-primary to-blue-900 text-white mx-auto py-2 px-5 rounded-full text-base font-bold flex items-center m-5 shadow-medium hover:shadow-strong hover:scale-105 transition-all"
              >
                Continuar
              </button>
            </div>
          </form>
        </div>
        <div *ngIf="updateDataType === 'direction'">
          <form [formGroup]="stepTwoForm" class="space-y-2">
            <!-- Encabezado -->
            <div class="w-fit mb-6 mx-4 md:mx-0">
              <h3 class="text-lg font-bold text-primary">
                {{
                  type === "sale" ? "Datos de envío" : "Datos de instalación"
                }}
              </h3>
              <div
                class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
              ></div>
            </div>

            <!-- Instrucción -->
            <p class="text-primary text-sm -mb-1 ml-1">
              Busca tu dirección y selecciónala en el listado.
            </p>

            <!-- Dirección completa con Autocomplete -->
            <div class="w-full">
              <label class="block text-sm font-medium text-primary mb-2">
                Dirección completa <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <input
                  ngx-google-places-autocomplete
                  [options]="options"
                  #placesRef="ngx-places"
                  placeholder="Ej: Camarones 1981"
                  (onAddressChange)="handleAddressChange($event)"
                  formControlName="street"
                  type="search"
                  [ngModel]="street"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  [class.border-green-500]="isZipCodeValid"
                  [class.border-red-500]="zipCodeError"
                />
                <div
                  *ngIf="isValidatingZipCode"
                  class="absolute right-3 top-1/2 transform -translate-y-1/2"
                >
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
                <div
                  *ngIf="isZipCodeValid && !isValidatingZipCode"
                  class="absolute right-3 top-1/2 transform -translate-y-1/2"
                >
                  <mat-icon class="text-green-600">check_circle</mat-icon>
                </div>
              </div>
              <p
                *ngIf="zipCodeError"
                class="text-red-600 text-xs mt-1 font-semibold"
              >
                {{ zipCodeError }}
              </p>
            </div>

            <!-- Campos de dirección -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Número <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="street_number"
                  type="number"
                  placeholder="Número"
                  [ngModel]="street_number"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Piso/Depto./Timbre</label
                >
                <input
                  formControlName="floor"
                  type="text"
                  placeholder="Ej: 3B"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Ciudad <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="city"
                  [(ngModel)]="city"
                  type="search"
                  placeholder="Ciudad"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Provincia <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="province"
                  [(ngModel)]="province"
                  type="search"
                  placeholder="Provincia"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Barrio/Localidad</label
                >
                <input
                  formControlName="department"
                  [(ngModel)]="department"
                  type="search"
                  placeholder="Barrio/Localidad"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2"
                  >Código Postal <span class="text-red-500">*</span></label
                >
                <input
                  formControlName="postal_code"
                  [(ngModel)]="zipCode"
                  type="text"
                  placeholder="Código Postal"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
            </div>

            <!-- Comentarios -->
            <div class="w-full">
              <label class="block text-sm font-medium text-primary mb-2"
                >Comentarios (ej. entre calles, reja negra, etc.)</label
              >
              <textarea
                formControlName="observations"
                rows="2"
                placeholder="Agregue detalles adicionales..."
                class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full resize-none"
              ></textarea>
            </div>

            <!-- Checkbox misma dirección para facturación -->
            <div class="flex items-center py-2">
              <mat-checkbox
                formControlName="sameAddressAsInstallation"
                class="text-primary"
                [checked]="true"
              >
                Usar misma dirección para facturación
              </mat-checkbox>
            </div>
            <!-- Datos de Facturación (condicional) -->
            <div
              *ngIf="!stepTwoForm.get('sameAddressAsInstallation')?.value"
              class="space-y-2"
            >
              <div class="w-fit mb-6 mx-4 md:mx-0 mt-8">
                <h3 class="text-lg font-bold text-primary">
                  Datos de Facturación
                </h3>
                <div
                  class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
                ></div>
              </div>
              <!-- Dirección completa con Autocomplete (Facturación) -->
              <div class="w-full">
                <label class="block text-sm font-medium text-primary mb-2">
                  Dirección completa <span class="text-red-500">*</span>
                </label>
                <input
                  ngx-google-places-autocomplete
                  [options]="options"
                  #billPlacesRefTwo="ngx-places"
                  placeholder="Ej: Camarones 1981"
                  (onAddressChange)="
                    handleBillingAddressChange($event, 'stepTwo')
                  "
                  formControlName="bill_street"
                  type="search"
                  [ngModel]="bill_street"
                  class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                />
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Calle <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="bill_street"
                    type="text"
                    placeholder="Calle"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Número <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="bill_street_number"
                    type="number"
                    placeholder="Número"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Piso/Depto./Timbre</label
                  >
                  <input
                    formControlName="bill_floor"
                    type="text"
                    placeholder="Ej: 3B"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Ciudad <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="bill_city"
                    type="text"
                    placeholder="Ciudad"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Provincia <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="bill_province"
                    type="text"
                    placeholder="Provincia"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
                <div class="w-full">
                  <label class="block text-sm font-medium text-primary mb-2"
                    >Código Postal <span class="text-red-500">*</span></label
                  >
                  <input
                    formControlName="bill_postal_code"
                    type="text"
                    placeholder="Código Postal"
                    class="border border-gray-300 rounded-lg px-4 py-3 text-base font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full"
                  />
                </div>
              </div>
            </div>

            <!-- Acciones -->
            <div class="flex">
              <button
                (click)="step = 2; handleCancelButton()"
                class="bg-gray-100 text-primary py-2 px-5 rounded-full text-base md:text-xl font-bold m-5 hover:bg-gray-200 shadow-sm hover:shadow-medium transition-all"
              >
                Cancelar
              </button>
              <button
                (click)="step = 2"
                [disabled]="
                  !isZipCodeValid || zipCodeError || isValidatingZipCode
                "
                class="bg-gradient-to-br from-primary to-blue-900 text-white mx-auto py-2 px-5 rounded-full text-base font-bold flex items-center m-5 shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span
                  *ngIf="isValidatingZipCode"
                  class="flex items-center gap-2"
                >
                  <mat-spinner diameter="16"></mat-spinner>
                  Validando...
                </span>
                <span *ngIf="!isValidatingZipCode">Continuar</span>
              </button>
            </div>
          </form>

          <!-- Mapa: mantener el contenedor siempre en el DOM para evitar errores de inicialización -->
          <div class="mt-6">
            <h3
              class="font-semibold text-lg text-primary mb-2"
              [ngStyle]="viewMap ? { display: 'block' } : { display: 'none' }"
            >
              {{
                type === "sale"
                  ? "Lugar de entrega del producto:"
                  : "Verifica el lugar en el mapa:"
              }}
            </h3>
            <div
              id="map"
              class="w-full rounded-3xl mt-4"
              [ngClass]="{ 'shadow-lg': viewMap }"
              [ngStyle]="viewMap ? { 'height.px': 400 } : { 'height.px': 0 }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="step === 2" class="col-span-1 bg-white rounded-r-xl">
      <div *ngIf="type === 'sub'">
        <!-- <div
          class="rounded-tr-xl bg-green-500 md:px-10 px-4 py-4 flex items-center justify-center gap-4"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            ></path>
          </svg>
          <h1 class="text-white font-semibold text-xl">
            Todos tus datos están 100% protegidos
          </h1>
        </div>
        <div class="p-5 mb-5 bg-gray-200">
          <span
            ><b>Increase</b> es un intermediario entre nuestra plataforma y los
            bancos para todos los pagos con Tarjeta de Crédito. El sistema envía
            la información de las transacciones con tarjetas de forma automática
            y proporciona al comercio una visión general de la evolución de sus
            pagos, como asi aumenta la comunicación con el cliente, siempre que
            no se pueda realizar un pago, tu tarjeta este próxima a vencer o tu
            pago se haya realizado con éxito.
          </span>
        </div>

        <div
          class="flex justify-between flex-col md:flex-row md:space-x-4 items-center md:pr-10 pr-4 mt-2"
        >
          <div>
            <img src="assets/cards.png" class="" alt="" />
          </div>
          <div class="">
            <img src="assets/increase.png" class="" alt="" />
          </div>
        </div> -->
      </div>
      <div
        *ngIf="type === 'sale'"
        class="hidden md:flex flex-col gap-1 justify-center items-center mb-8"
      >
        <h1 class="text-primary font-semibold">Pagas con</h1>
        <img
          class="bg-gray-100 rounded-lg p-2 w-full h-auto"
          src="assets/formas_de_pago.png"
          alt="Mercado Pago logo"
        />
        <h2 class="text-primary font-semibold">hasta 6 cuotas sin interés.</h2>
      </div>
      <div class="px-4 md:px-0 pt-4">
        <div class="flex items-center gap-3 mb-2">
          <!--  <span class="inline-flex w-8 h-8 items-center justify-center rounded-full bg-primary text-white">
            <mat-icon>assignment_turned_in</mat-icon>
          </span> -->
          <div class="w-fit">
            <h2 class="text-primary font-semibold text-xl md:text-2xl">
              Confirma tus datos
            </h2>
            <div
              class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
            ></div>
          </div>
        </div>
      </div>

      <div
        *ngIf="step > 1"
        class="text-primary text-sm justify-center bg-white shadow-medium rounded-2xl p-5 mb-4 mt-2 mx-4 md:mx-0"
      >
        <div class="flex items-center justify-between">
          <!-- Primera columna con datos del usuario -->
          <div class="mb-4 md:mb-0">
            <p class="text-lg font-bold">
              <ng-container *ngIf="userData?.first_name || userData?.last_name">
                {{ userData?.first_name }}, {{ userData?.last_name }}
              </ng-container>
              <ng-container
                *ngIf="!(userData?.first_name || userData?.last_name)"
              >
                {{ user?.name }}
              </ng-container>
            </p>
            <p class="text-gray-500">{{ user?.email }}</p>
            <p class="text-gray-500">{{ userData?.phone }}</p>
          </div>

          <!-- Segunda columna con el icono de lápiz -->
          <div class="text-primary">
            <button
              (click)="updateData('user')"
              class="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1.5 text-sm font-bold shadow-sm hover:shadow-medium transition-all"
            >
              <mat-icon class="!text-base">edit</mat-icon>
              <span class="hidden md:inline">Editar</span>
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="step > 1"
        class="text-primary text-sm justify-center bg-white shadow-medium rounded-2xl p-5 mx-4 md:mx-0"
      >
        <div class="flex justify-between items-center">
          <!-- Primera columna con datos de lugar de instalación -->
          <div class="mb-4 md:mb-0">
            <p *ngIf="type === 'sub'; sub" class="font-semibold">
              Lugar de instalación:
            </p>
            <p *ngIf="type === 'sale'" class="font-semibold">
              Lugar de entrega del producto:
            </p>
            <!-- Si hay dirección, renderiza esto -->
            <div *ngIf="stepTwoForm?.value?.street; userAddress">
              <p class="uppercase">
                {{ stepTwoForm?.value?.street }}
                {{ stepTwoForm?.value?.street_number
                }}<span *ngIf="stepTwoForm.get('floor')?.value"
                  >, {{ stepTwoForm.get("floor")?.value }}</span
                >
              </p>
              <p class="text-gray-600 uppercase">
                <span *ngIf="stepTwoForm.get('department')?.value"
                  >{{ stepTwoForm.get("department")?.value }},
                </span>
                {{ stepTwoForm?.value?.city
                }}<span *ngIf="stepTwoForm.get('province')?.value"
                  >, {{ stepTwoForm.get("province")?.value }}</span
                ><span *ngIf="stepTwoForm.get('postal_code')?.value">
                  (CP: {{ stepTwoForm.get("postal_code")?.value }})</span
                >
              </p>
              <p
                *ngIf="stepTwoForm.get('observations')?.value"
                class="text-gray-500 text-xs mt-1 italic uppercase"
              >
                {{ stepTwoForm.get("observations")?.value }}
              </p>
            </div>

            <!-- Si NO hay dirección, renderiza esto -->
            <ng-template #userAddress>
              <!-- Si no hay datos de dirección en ningún lado, mostrar mensaje y botón -->
              <div
                *ngIf="
                  !user?.addresses || !user?.addresses[0]?.address;
                  else showUserAddress
                "
              >
                <div
                  class="bg-gradient-to-r from-yellow-50 to-amber-50 shadow-medium rounded-2xl p-4 mb-2"
                >
                  <div class="flex items-center mb-2">
                    <mat-icon class="text-yellow-600 mr-2">warning</mat-icon>
                    <p class="text-yellow-800 font-bold">Dirección requerida</p>
                  </div>
                  <p class="text-yellow-700 text-sm mb-3">
                    Para continuar con
                    {{ type === "sub" ? "la instalación" : "el envío" }},
                    necesitamos configurar tu dirección.
                  </p>
                  <button
                    (click)="updateData('direction')"
                    class="bg-gradient-to-br from-primary to-blue-900 text-white px-4 py-2 rounded-full text-sm font-bold shadow-medium hover:shadow-strong hover:scale-105 transition-all w-full flex items-center justify-center gap-2"
                  >
                    <mat-icon>location_on</mat-icon>
                    Configurar dirección ahora
                  </button>
                </div>
              </div>
              <ng-template #showUserAddress>
                <p class="uppercase">
                  {{ user?.addresses[0]?.address }}
                  <span *ngIf="user?.addresses[0]?.floor"
                    >, {{ user?.addresses[0]?.floor }}</span
                  >
                </p>
                <p class="text-gray-600 uppercase">
                  <span *ngIf="user?.addresses[0]?.department"
                    >{{ user?.addresses[0]?.department }},
                  </span>
                  {{ user?.addresses[0]?.city }}
                  <span *ngIf="user?.addresses[0]?.province"
                    >, {{ user?.addresses[0]?.province }}</span
                  >
                  <span *ngIf="user?.addresses[0]?.postal_code">
                    (CP: {{ user?.addresses[0]?.postal_code }})</span
                  >
                </p>
                <p
                  *ngIf="user?.addresses[0]?.observations"
                  class="text-gray-500 text-xs mt-1 italic uppercase"
                >
                  {{ user?.addresses[0]?.observations }}
                </p>
              </ng-template>
            </ng-template>
          </div>

          <!-- Segunda columna con el icono de lápiz -->
          <div class="text-primary">
            <button
              (click)="updateData('direction'); viewMap = false"
              class="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1.5 text-sm font-bold shadow-sm hover:shadow-medium transition-all"
            >
              <mat-icon class="!text-base">edit</mat-icon>
              <span class="hidden md:inline">Editar</span>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-6">
        <form [formGroup]="stepTwoForm" (ngSubmit)="processPayment()">
          <div class="mt-2 mb-2">
            <div class="px-4 md:px-0">
              <div class="w-fit">
                <label for="name" class="text-lg font-bold text-primary"
                  >Método de pago</label
                >
                <div
                  class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
                ></div>
              </div>
            </div>

            <!-- Para suscripciones: mostrar método fijo -->
            <div
              *ngIf="type === 'sub'"
              class="bg-white text-primary shadow-medium rounded-2xl p-5 mt-3 mx-4 md:mx-0"
            >
              <div class="flex items-center justify-between gap-3">
                <div class="flex items-center gap-3">
                  <span
                    class="inline-flex w-9 h-9 items-center justify-center rounded-full bg-primary/10 text-primary"
                  >
                    <mat-icon>credit_card</mat-icon>
                  </span>
                  <div>
                    <div class="font-semibold leading-none">
                      Mercado Pago Suscripción
                    </div>
                    <div class="text-xs text-gray-600 mt-1">
                      Tarjeta de Crédito
                    </div>
                  </div>
                </div>
                <span
                  class="inline-flex items-center text-green-600 text-sm font-medium"
                >
                  <mat-icon class="!text-base mr-1">check_circle</mat-icon>
                  Seleccionado
                </span>
              </div>
            </div>

            <!-- Para compras: mostrar select normal -->
            <div *ngIf="type === 'sale'">
              <div
                class="bg-white text-primary shadow-medium rounded-2xl p-5 mt-3 mx-4 md:mx-0"
              >
                <select
                  id="name"
                  name="name"
                  formControlName="payment_method"
                  autocomplete="name"
                  class="bg-white text-primary rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-primary/30"
                  (change)="onPaymentMethodChange($event.target.value)"
                  [disabled]="isPaymentMethodDisabled"
                >
                  <option
                    *ngFor="let method of paymentMethods"
                    [value]="method.value"
                    [selected]="
                      stepTwoForm.get('payment_method')?.value === method.value
                    "
                  >
                    {{ method.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Para suscripciones: mostrar información sobre el checkout -->
          <div
            *ngIf="type === 'sub'"
            class="mt-4 mb-4 p-5 shadow-medium rounded-2xl bg-gradient-to-r from-blue-50 to-indigo-50 mx-4 md:mx-0"
          >
            <div class="flex items-center mb-2">
              <mat-icon class="text-primary mr-2">info</mat-icon>
              <h3 class="text-lg font-semibold text-primary">
                Información de Pago
              </h3>
            </div>
            <p class="text-gray-700 mb-2">
              Al continuar, será redirigido al checkout seguro de Mercado Pago
              para:
            </p>
            <ul class="text-sm text-gray-600 list-disc ml-6 space-y-1">
              <li>Ingresar los datos de su tarjeta de crédito</li>
              <li>Completar la configuración de la suscripción</li>
              <li>Confirmar el plan de pagos mensual</li>
            </ul>
            <div
              class="mt-3 p-2 bg-white border border-blue-200 rounded-xl text-center"
            >
              <span class="text-sm text-gray-600"
                >🔒 Proceso 100% seguro con certificación SSL</span
              >
            </div>
          </div>

          <div class="flex justify-center items-center md:gap-8 mb-4">
            <!-- Botón para suscripciones - checkout link -->
            <button
              *ngIf="
                type === 'sub' && !hasPaymentError && !isRedirecting && !loading
              "
              type="submit"
              [disabled]="stepTwoForm.invalid"
              class="bg-gradient-to-br from-primary to-blue-900 text-white w-full p-3 rounded-full text-xl md:text-2xl font-bold ml-2 mr-2 my-5 shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <div class="flex justify-center items-center gap-3">
                <mat-icon>credit_card</mat-icon>
                <span>Continuar al Checkout</span>
              </div>
            </button>

            <!-- Indicador de procesamiento/redirección para suscripciones -->
            <div
              *ngIf="
                type === 'sub' && (loading || isRedirecting) && !hasPaymentError
              "
              class="bg-gradient-to-br from-green-500 to-emerald-600 text-white w-full p-3 rounded-full text-xl md:text-2xl font-bold ml-2 mr-2 my-5 text-center shadow-medium"
            >
              <div class="flex justify-center items-center gap-3">
                <mat-spinner diameter="24" class="inline-block"></mat-spinner>
                <span *ngIf="!isRedirecting">Procesando suscripción...</span>
                <span *ngIf="isRedirecting">Redirigiendo al checkout...</span>
              </div>
            </div>

            <!-- Botón de reintento cuando hay error -->
            <button
              *ngIf="type === 'sub' && hasPaymentError"
              type="button"
              (click)="retryPayment()"
              class="bg-gradient-to-br from-red-600 to-red-700 text-white w-full p-3 rounded-full text-xl md:text-2xl font-bold ml-2 mr-2 my-5 shadow-medium hover:shadow-strong hover:scale-105 transition-all"
            >
              <div class="flex justify-center items-center gap-3">
                <mat-icon>refresh</mat-icon>
                <span>Intentar nuevamente</span>
              </div>
            </button>

            <!-- Botón para compras normales -->
            <button
              *ngIf="type === 'sale'"
              type="submit"
              [disabled]="stepTwoForm.invalid"
              class="bg-gradient-to-br from-primary to-blue-900 text-white w-full p-3 rounded-full text-xl md:text-2xl font-bold ml-2 mr-2 my-5 shadow-medium hover:shadow-strong hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <div class="flex justify-center items-center gap-3">
                <span class="material-symbols-outlined">shopping_cart</span>
                <span>Procesar Compra</span>
              </div>
            </button>
          </div>
        </form>
        <div
          *ngIf="type === 'sale'"
          class="bg-gradient-to-b from-gray-50 to-white rounded-2xl p-4 mt-3 shadow-medium mx-4 md:mx-0"
        >
          <div class="flex flex-col text-center">
            <div class="font-normal text-xs space-y-1 text-left inline-block">
              <p>
                <span class="font-bold">•</span> CABA y GBA:
                <span class="font-semibold">1 día hábil</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Pcia de Bs As, Capitales de
                Córdoba, Entre Ríos, Mendoza, Neuquén y Santa Fé:
                <span class="font-semibold">Hasta 3 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Resto de Provincias
                continentales:
                <span class="font-semibold">Hasta 7 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Tierra del Fuego:
                <span class="font-semibold">Hasta 14 días hábiles</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
